import { Component, OnInit } from "@angular/core";
import { AppServerAPI, ServiceResponse } from "@sdbn/common";
import { CameraDefinition, NumberPlateScan } from "../../yard-simulator.model";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from "@angular/forms";

@Component({
    selector: "app-number-plate-scan",
    templateUrl: "./number-plate-scan.component.html",
    styleUrls: ["./number-plate-scan.component.css"],
    standalone: false
})
export class NumberPlateScanComponent implements OnInit {

  cameraSelected: CameraDefinition;
  cameras: CameraDefinition[];

  numberPlateNumber: string;
  weighingSource?: string;
  weight?: number;
  image?: File;

  formGroup = new FormGroup({});

  constructor(
    private service: AppServerAPI
  ) {
    this.formGroup.addControl("numberPlateNumber", new FormControl("", []));
    this.formGroup.addControl("cameraSelection", new FormControl("", []));
    this.formGroup.addControl("weighingSource", new FormControl(undefined, []));
    this.formGroup.addControl("weight", new FormControl(undefined, []));
    this.formGroup.valueChanges.subscribe((formValues) => {
      this.numberPlateNumber = formValues.numberPlateNumber;
      this.weighingSource = formValues.weighingSource;
      this.weight = formValues.weight;
    });
  }

  ngOnInit() {
    this.service
      .execute<CameraDefinition[]>(
        '/client/admin/yard-simulator/cameras',
        {}
      )
      .subscribe((cameras) => {
        this.cameras = cameras;
      });
  }

  onCameraSelection(camera: CameraDefinition) {
    this.cameraSelected = camera;
  }

  onFileSelected(event: Event) {
    const imageElement = event.target as HTMLInputElement;
    if (imageElement.files?.length ?? 0 > 0) {
      this.image = imageElement.files![0] ?? undefined;
    }
  }

  onButtonTrigger() {
    let promise;
    if (this.image) {
      promise = this.fileToBase64(this.image);
    } else {
      promise = Promise.resolve(undefined);
    }
    promise.then((scannedNumberplateImage) => {
      const numberPlateScan = new NumberPlateScan({
        identifier: this.cameraSelected.identifier,
        scannedNumber: this.numberPlateNumber,
        weighingSource: this.weighingSource,
        weight: this.weight,
        scannedNumberplateImage: scannedNumberplateImage
      });

      this.service
        .execute<ServiceResponse>(
          '/client/admin/yard-simulator/number-plate-scan',
          numberPlateScan
        )
        .subscribe((response) => {
          console.log(response.status, ":\n", response.responseMessages);
        });
      });
    
  }


  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string;

        // Entfernt "data:image/png;base64,"
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

}
